export const loadedScripts: Record<string, Promise<void> | undefined> = {}

export function loadScript(src: string): Promise<void> {
  if (loadedScripts[src]) {
    return loadedScripts[src]
  }

  loadedScripts[src] = new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }

    const script = document.createElement("script")
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject()
    document.head.appendChild(script)
  })

  return loadedScripts[src]
}
